// packages import
import { Box, IconButton, InputAdornment, TextField } from '@mui/material'
import { FC, KeyboardEvent } from 'react'
// others
import { SearchCasesInDashboardProps } from '../../../interfaceTypes'
import { CrossIcon } from '../../../assets/images'
import { CASE_SEARCH_PLACEHOLDER_WITH_CLIENT } from '../../../constants'

export const SearchCases: FC<SearchCasesInDashboardProps> = ({ searchValue, setSearchValue }) => {
  const searchHandler = (event: KeyboardEvent<HTMLInputElement>) => {
    const { key } = event

    if (key === 'Enter') {
      setSearchValue(searchValue)
    }
  }

  const clearSearchHandler = () => setSearchValue('')

  return (
    <Box maxWidth={265} pr={1} width="100%">
      <TextField
        label={CASE_SEARCH_PLACEHOLDER_WITH_CLIENT}
        onKeyDown={searchHandler}
        onChange={({ target: { value } }) => {
          setSearchValue(value)
        }}
        value={searchValue}
        size="small"
        fullWidth
        variant="outlined"
        InputProps={{
          endAdornment: searchValue ? (
            <InputAdornment position="end" onClick={clearSearchHandler}>
              <IconButton
                sx={{ p: 0, svg: { maxWidth: '10px' } }}
                onClick={clearSearchHandler}
                aria-label="clear search"
              >
                <CrossIcon />
              </IconButton>
            </InputAdornment>
          ) : undefined
        }}
      />
    </Box>
  )
}
